<template>
  <div
    ref="changeBasket"
    class="change-basket"
    :class="{ 'change-basket--active': props.source.count }"
  >
    <button
      @click="onAddBasket"
      class="btn btn--green change-basket__btn"
      type="button"
    ></button>
    <div
      ref="counter"
      :class="{ 'counter--active': props.source.count }"
      class="counter"
    >
      <button
        class="btn btn--green counter__btn counter__btn--minus"
        type="button"
        @click="onChangeCount('minus')"
      ></button>
      <div class="counter__info" @click="onShowAddCount">
        <div class="counter__info-value">{{ source.count }} шт</div>
        <div class="counter__info-description">
          {{ priceFormat(source.count * source.basePrice) }}
        </div>
      </div>
      <button
        class="btn btn--green counter__btn counter__btn--plus"
        type="button"
        @click="onChangeCount('plus')"
      ></button>
    </div>

    <div
      class="add-count"
      ref="addCount"
      v-show="isAddCount"
      @click="addCountInput.focus()"
    >
      <div class="add-count__title">Введите количество</div>
      <div class="add-count__info">
        <input
          type="number"
          ref="addCountInput"
          v-model="count"
          @keyup.enter="handleEnter"
        />
        <span class="add-count__text">{{ count }} шт</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { eventBus } from "@/helpers/eventBus";
  import { priceFormat } from "@/helpers/priceFormat";
  import { IProduct } from "@/models/models";
  import { onMounted, onUnmounted, PropType, ref } from "vue";

  const props = defineProps({
    source: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  });

  const changeBasket = ref(null as unknown as HTMLElement);

  const counter = ref(null as unknown as HTMLElement);

  const count = ref<number>(1 as number);

  const basket = ref<Array<IProduct>>([] as Array<IProduct>);

  const isAddCount = ref<boolean>(false as boolean);

  const addCountInput = ref(null as unknown as HTMLElement);

  const onShowAddCount = () => {
    isAddCount.value = true;

    basket.value.forEach((basketItem) => {
      if (basketItem.id == props.source.id) {
        count.value = basketItem.count;
      }
    });

    setTimeout(() => {
      addCountInput.value.focus();
    }, 100);
  };

  const handleEnter = () => {
    isAddCount.value = false;

    basket.value.forEach((basketItem) => {
      if (basketItem.id == props.source.id) {
        basketItem.count = count.value != 0 ? count.value : 1;
      }
    });

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    if (basket.value.length != 0) {
      basket.value.forEach((basketItem) => {
        if (basketItem.id == props.source.id) {
          if (basketItem.count == 0) {
            props.source.count = 0;
          } else {
            props.source.count = basketItem.count;
          }
        }
      });
    } else {
      if (basket.value.length != 0) {
        basket.value = basket.value.filter(
          (basketItem) => basketItem.id != props.source.id
        );
      }
    }
  };

  const deleteCart = (card: IProduct) => {
    if (card.id == props.source.id) {
      props.source.count = 0;
    }
  };

  const clearCart = () => {
    props.source.count = 0;
  };

  const handleClickOutside = (event: any) => {
    if (changeBasket.value && !changeBasket.value.contains(event.target)) {
      if (isAddCount.value) {
        basket.value.forEach((basketItem) => {
          if (basketItem.id == props.source.id) {
            basketItem.count = count.value != 0 ? count.value : 1;
          }
        });

        localStorage.setItem("basket", JSON.stringify(basket.value));

        eventBus.emit("cart-updated", {});
      }
      isAddCount.value = false;
    }

    if (event.target.classList.contains("counter__btn")) {
      isAddCount.value = false;
    }
  };

  onMounted(() => {
    updateCart();
    eventBus.on("delete-card", deleteCart);
    eventBus.on("cart-clear", clearCart);
    eventBus.on("cart-updated", updateCart);
    document.addEventListener("click", handleClickOutside);
  });

  onUnmounted(() => {
    eventBus.off("delete-card", deleteCart);
    eventBus.off("cart-clear", clearCart);
    eventBus.off("cart-updated", updateCart);
    document.removeEventListener("click", handleClickOutside);
  });

  const onAddBasket = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    // changeBasket.value.classList.add("change-basket--active");
    // counter.value.classList.add("counter--active");

    props.source.count = count.value;

    basket.value.push(props.source);

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

  const onChangeCount = (value: string) => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    if (value == "minus") {
      props.source.count--;
      if (props.source.count == 0) {
        // changeBasket.value?.classList.remove("change-basket--active");
        // counter.value?.classList.remove("counter--active");

        if (basket.value.length != 0) {
          basket.value = basket.value.filter(
            (basketItem) => basketItem.id != props.source.id
          );
        }
      } else {
        if (basket.value.length != 0) {
          basket.value.forEach((basketItem) => {
            if (basketItem.id == props.source.id) {
              basketItem.count = props.source.count;
            }
          });
        }
      }
    } else {
      if (basket.value.length != 0) {
        props.source.count++;
        basket.value.forEach((basketItem) => {
          if (basketItem.id == props.source.id) {
            basketItem.count = props.source.count;
          }
        });
      }
    }
    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };
</script>
<style scoped lang="scss">
  .change-basket {
    width: 100%;
    margin-left: auto;
    right: 0;
    transition: width 0.3s ease-in-out;
    &__btn {
      position: relative;
      z-index: 4;
      margin: 4px;
      margin-left: auto;
      width: 32px;
      height: 32px;
      background-image: url("@/assets/icons/cart.svg");
      background-repeat: no-repeat;
      background-position: center;
    }

    &--active {
      position: absolute;
      width: 100%;
      transition: width 0.3s ease-in-out, position 0.1s ease-in-out;

      .change-basket {
        &__btn {
          z-index: auto;
        }
      }
    }
  }

  .add-count {
    width: 100%;
    position: absolute;
    transform: translateY(-100%);
    top: -5px;
    z-index: 2;
    background-color: $white;
    border: 1px solid $acentGreen;
    border-radius: 8px;
    padding: 5px;

    &__title {
      font-size: 12px;
      text-align: center;
    }

    &__info {
      display: flex;
      justify-content: center;
      font-size: 16px;
      overflow: hidden;
      input {
        font-size: 16px;
        font-family: $FFCircle;
        width: fit-content;
        position: absolute;
        color: transparent;
        caret-color: $almostBlack;
        text-align: center;
        padding-right: 20px;
      }
    }

    &__text {
      white-space: nowrap;
    }
  }
</style>
